export const login = {
  name: "login" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21 2.1a.9.9 0 0 1 .9.9v18a.9.9 0 0 1-.9.9H11a.9.9 0 0 1 0-1.8h9.1V3.9H11a.9.9 0 1 1 0-1.8h10Zm-4.364 9.264a.9.9 0 0 1 0 1.272l-5 5a.9.9 0 0 1-1.272-1.272l3.463-3.464H3a.9.9 0 0 1 0-1.8h10.827l-3.463-3.464a.9.9 0 1 1 1.272-1.272l5 5Z" clip-rule="evenodd"/></svg>`,
  keywords: ["login"],
  category: "action" as const,
};
